import type { ReactNode } from 'react';
import { CardInfo } from './CardInfo';

export type CaptureMetadataCell = {
  id: string;
  label: string;
  value: ReactNode;
  minWidth?: number;
  maxWidth?: number;
  truncate?: boolean;
};

export type CaptureMetadataStripProps = {
  cells: CaptureMetadataCell[];
};

export const CaptureMetadataStrip = ({ cells }: CaptureMetadataStripProps) => (
  <div className="capture-metadata-strip">
    {cells.map((cell) => (
      <CardInfo
        key={cell.id}
        label={cell.label}
        data={cell.value}
        haveBorder
        truncate={cell.truncate}
        style={{
          minWidth: cell.minWidth,
          maxWidth: cell.maxWidth,
        }}
      />
    ))}
  </div>
);
